export function setCurrent(element) {
    var elements = typeof element !== 'undefined' ? [element] : Array.prototype.slice.call(document.getElementsByClassName('current'));
    elements.forEach(function (element) {
        if (element.classList.contains('current')) {
            element.classList.add(element.classList[0] + '_current');
            if (element.classList.length > 1) {
                element.classList.remove('current');
            }
        }
    });
}
export default {
    type: 'dom',
    init: function (GG) {
        if (GG.config.setCurrent) {
            setCurrent(GG.config.setCurrentElement);
            GG.log('AutoCurrent DOMContentLoaded class transformation done.');
        }
        if (typeof window.jQuery !== 'undefined') {
            this.plugin.call(GG);
            GG.log('AutoCurrent plugin loaded.');
        }
        else {
            GG.log('AutoCurrent plugin needs jQuery.');
        }
    },
    plugin: function (element, selector) {
        var app = this;
        if (typeof element === 'undefined')
            element = $('body');
        selector = selector || 'a';
        element.on('mouseup', selector, function () {
            var $parent = $(this).parent(), $wrapper = $parent.parent(), regexp = new RegExp('^(.+)_current$', 'i');
            if ($(this).data('dispatch') && $($(this).data('dispatch')).length > 0) {
                $parent = $(this).closest($(this).data('dispatch'));
                $wrapper = $parent.parent();
            }
            var parentBlockClass = $parent[0].className.split(/\s+/)[0], thisBlockClass = $(this)[0].className.split(/\s+/)[0], flagNotSingle = true;
            if (!thisBlockClass ||
                (parentBlockClass.length &&
                    $('.' + parentBlockClass + ':visible').length === 1 &&
                    $('.' + parentBlockClass + ' .' + thisBlockClass + ':visible').length === 1)) {
                if (!$(this).is('.currenton'))
                    flagNotSingle = false;
            }
            var flagNotContent = true;
            var flagNoAutoCurrent = false;
            if ($(this).closest('.noautocurrent').length > 0) {
                flagNoAutoCurrent = true;
                if (app.config.log)
                    console.log('.' +
                        $(this)
                            .closest('.noautocurrent')[0]
                            .className.split(/\s+/)[0] +
                        ': Autocurrent is toggled off for this container');
            }
            var flagNoUnCurrent = false;
            if ($(this).closest('.nouncurrent').length > 0) {
                flagNoUnCurrent = true;
                if (app.config.log)
                    console.log('.' +
                        $(this)
                            .closest('.nouncurrent')[0]
                            .className.split(/\s+/)[0] +
                        ': Uncurrent is toggled off for this container');
            }
            var flagToggleCurrent = false;
            if ($(this).closest('.togglecurrent').length > 0) {
                flagToggleCurrent = true;
            }
            var flagIsCurrent = false;
            if (regexp.test($(this)[0].className) || (regexp.test($parent[0].className) && flagNotSingle)) {
                flagIsCurrent = true;
                if (!flagToggleCurrent) {
                    if (app.config.log)
                        console.log("Link state is 'current', aborting");
                    var $me_1 = $(this);
                    $me_1.data('breakEvent', 1);
                    var removeAbort = function () {
                        $me_1.data('breakEvent', 0);
                    };
                    setTimeout(removeAbort, 100);
                    return false;
                }
            }
            if (!$(this).data('noautocurrent') &&
                flagNotSingle &&
                flagNotContent &&
                ((typeof flagNoAutoCurrent !== 'undefined' && !flagNoAutoCurrent) || typeof flagNoAutoCurrent === 'undefined')) {
                var parentFirstClass = $parent[0].className.split(/\s+/)[0], parentCurrents = [];
                if (parentBlockClass.length &&
                    $('.' + parentBlockClass + ':visible').length > 1 &&
                    $(this)
                        .closest('.' + parentFirstClass)
                        .parent()
                        .find('.' + parentBlockClass).length > 1) {
                    if (!flagNoUnCurrent)
                        $wrapper
                            .find('.' + parentFirstClass + '_current')
                            .removeClass(parentFirstClass + '_current')
                            .data('current', false);
                    if (flagNoUnCurrent && flagIsCurrent && flagToggleCurrent) {
                        $(this)
                            .closest('.' + parentFirstClass + '_current')
                            .removeClass(parentFirstClass + '_current')
                            .data('current', false);
                    }
                    if (!flagToggleCurrent || !flagIsCurrent) {
                        parentCurrents.push(parentFirstClass + '_current');
                        for (var i = 0, k = parentCurrents.length; i < k; i++) {
                            $parent.addClass(parentCurrents[i]).data('current', true);
                        }
                    }
                }
                if ($(this).is('.currenton') && parentFirstClass) {
                    if ($parent.is('.' + parentFirstClass + '_current')) {
                        $parent.removeClass(parentFirstClass + '_current');
                    }
                    else {
                        $parent.addClass(parentFirstClass + '_current');
                    }
                }
                var childFirstClass = $(this)[0].className.split(/\s+/)[0], childCurrents = [], parent_1 = parentBlockClass.length
                    ? $(this)
                        .parent()
                        .parent()
                    : $(this).parent();
                if ($(this).data('dispatch') && $($(this).data('dispatch')).length > 0) {
                    parent_1 = $(this).closest($(this).data('dispatch'));
                }
                $('.' + childFirstClass + '_current', flagNoUnCurrent ? $parent : parent_1)
                    .removeClass(childFirstClass + '_current')
                    .data('current', false);
                if (flagNoUnCurrent && flagIsCurrent && flagToggleCurrent) {
                    $('.' + childFirstClass + '_current', flagNoUnCurrent ? $parent : parent_1)
                        .removeClass(parentFirstClass + '_current')
                        .data('current', false);
                }
                if (!$(this).data('dispatch') && (!flagToggleCurrent || !flagIsCurrent)) {
                    childCurrents.push(childFirstClass + '_current');
                    for (var i = 0, k = childCurrents.length; i < k; i++) {
                        $(this)
                            .addClass(childCurrents[i])
                            .data('current', true);
                    }
                }
            }
        });
        element.on('click', 'a', function (e) {
            var href = $(this).attr('href');
            if (href === '#' || href === '') {
                e.preventDefault();
            }
        });
    }
};
